// extracted by mini-css-extract-plugin
export default {"container":"PanelAboveDashboard_container__FkqCf","leftSection":"PanelAboveDashboard_leftSection__G975B","rightSection":"PanelAboveDashboard_rightSection__MJKTD"};